export const SHOPPING_LIST_CLEAR = 'SHOPPING_LIST_CLEAR';
export const SHOPPING_LIST_ADD = 'SHOPPING_LIST_ADD';
export const SHOPPING_LIST_REMOVE = 'SHOPPING_LIST_REMOVE';
export const SHOPPING_LIST_INCREMENT = 'SHOPPING_LIST_INCREMENT';
export const SHOPPING_LIST_DECREMENT = 'SHOPPING_LIST_DECREMENT';
export const SHOPPING_LIST_SET_QUANTITY = 'SHOPPING_LIST_SET_QUANTITY';

export const setQuantity = (productId, quantity) => ({
  type: SHOPPING_LIST_SET_QUANTITY,
  payload: { productId, quantity },
});

export const increment = (productId, quantity) => ({
  type: SHOPPING_LIST_INCREMENT,
  payload: { productId, quantity },
});

export const decrement = (productId, quantity) => ({
  type: SHOPPING_LIST_DECREMENT,
  payload: { productId, quantity },
});

export const add = (productId) => ({
  type: SHOPPING_LIST_ADD,
  payload: productId,
});

export const remove = (productId) => ({
  type: SHOPPING_LIST_REMOVE,
  payload: productId,
});

export const clear = () => ({
  type: SHOPPING_LIST_CLEAR,
  payload: {},
});